import { withScriptjs, withGoogleMap, GoogleMap, Marker, GoogleMapProps } from "react-google-maps";
import { ICoordinate } from "@models/interfaces/ICoordinate";

interface IGoogleMapComp {
  coordinate: ICoordinate;
  mapProps?: GoogleMapProps;
}

const GoogleMapComp: React.FC<IGoogleMapComp> = (props: IGoogleMapComp) => {
  const extMapProps = props.mapProps || {},
    markerPosition = {
      lat: props.coordinate.latitude,
      lng: props.coordinate.longitude,
    };

  return (
    <GoogleMap defaultZoom={12} defaultCenter={markerPosition} {...extMapProps}>
      <Marker position={markerPosition} />
    </GoogleMap>
  );
};

export default withScriptjs(withGoogleMap<IGoogleMapComp>(GoogleMapComp));
